import { render, staticRenderFns } from "./OrderVolumeDiscount.vue?vue&type=template&id=5dc0b7a9"
import script from "./OrderVolumeDiscount.vue?vue&type=script&lang=js"
export * from "./OrderVolumeDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports